import React from 'react';

interface Service {
  title: string;
  description: string;
  icon: string;
  link: string;
}

interface ServicesGridProps {
  services?: Service[];
  columns?: number;
}

export const ServicesGrid: React.FC<ServicesGridProps> = ({
  services = [],
  columns = 3
}) => {
  return (
    <section className="nai-services-grid">
      <div className="container">
        <div className={`nai-grid nai-grid--cols-${columns}`}>
          {services.map((service, index) => (
            <div key={index} className="nai-service-card">
              <div className="nai-service-card__icon">
                {service.icon === 'roof' && '🏠'}
                {service.icon === 'repair' && '🔧'}
                {service.icon === 'inspect' && '🔍'}
              </div>
              <h3 className="nai-service-card__title">{service.title}</h3>
              <p className="nai-service-card__description">{service.description}</p>
              <a href={service.link} className="nai-service-card__link">
                Learn More →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};